'use client'

import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import AppDevelopmentSolutions from './components/AppDevelopmentSolutions'
import OnlinePresence from './components/OnlinePresence'
import MediaFromStrategy from './components/MediaFromStrategy'
import MediaWhyChoose from './components/MediaWhyChoose'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

const faqData = [
   {
      question:
         'What is Media & Entertainment software development, and why is it important?',
      answer:
         'Media & Entertainment software development produces digital solutions which serve the streaming of content and every step of the production cycle through distribution pathways and audience participation elements. Businesses need digital transformation to enhance user experiences and manage content delivery which results in increased revenue.',
   },
   {
      question:
         'How does Benzatine help media businesses with digital transformation?',
      answer:
         'Benzatine delivers custom media software products that consist of video streaming platforms and OTT applications as well as AI-based recommendation engines and DRM protection solutions. Media organizations receive help from Benzatine to build automated operations and connect AI data analytics tools while developing better user relationships.',
   },
   {
      question: 'What features should an OTT platform have?',
      answer:
         'A well-built OTT platform needs adaptive streaming capabilities together with content recommendation systems and multiple device accessibility and DRM defense and user subscription management features and instant analytics for user experience enhancement along with revenue growth advancement.',
   },
   {
      question: 'How does AI improve media content delivery and personalization?',
      answer:
         'Media content experiences enhance because AI analyzes audience behavior patterns while generating recommendations automatic video editing enabled ad targeting combinations and personalized content delivery for individual viewer interests.',
   },
   {
      question:
         'How do you ensure security and copyright protection in media software?',
      answer:
         'We use Digital Rights Management (DRM), end-to-end encryption, AI-driven anti-piracy features, and GDPR and copyright compliance to protect digital content.',
   },
   {
      question: 'What are the benefits of cloud-based media platforms?',
      answer:
         'Media businesses gain advantages from cloud-based platforms through dynamic scalability together with high-speed content transmission and worldwide network accessibility along with instant information synchronization and cost-efficiency for infrastructure needs.',
   },
   {
      question:
         'Can you develop a custom video streaming platform like Netflix or YouTube?',
      answer:
         'Our team specializes in creating distinct order-based streaming systems as well as real-time streaming solutions featuring AI-based recommendation engines as well as adaptive streaming features in addition to social media and multi-device compatibility elements.',
   },
   {
      question: 'How do interactive media solutions improve audience engagement?',
      answer:
         'User interaction, retention, and revenue-generating prospects are increased by interactive solutions such as live chat, real-time polling, gamification, interactive advertisements, and AI-powered engagement tools.',
   },
   {
      question:
         'What monetization options can be integrated into a media platform?',
      answer:
         'Media businesses reach their revenue potential through our subscription techniques combined with pay-per-view options and in-app purchasing capabilities and dynamic ad insertion as well as affiliate marketing functionality.',
   },
   {
      question:
         'How can I get started with Benzatine’s Media & Entertainment software development services?',
      answer:
         'You can begin by reaching out to our team for consultation. We evaluate your needs, suggest a tailor-made strategy, and create an expandable media platform to suit your business requirements.',
   },
]; 

function MediaAndEntertainmentPage() {
   useIndustriesNavbarScroll()
   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <AppDevelopmentSolutions />
         <OnlinePresence />
         <MediaFromStrategy />
         <MediaWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default MediaAndEntertainmentPage
